import { EditorTourStep } from './editor-tour.component';

export const REPORT_TEMPLATE_EDITOR_TOUR_STEPS: EditorTourStep[] = [
  {
    targetSelector: '.rte-shell__editor-area .ck-toolbar__items > .ck-button:first-child',
    titleKey: 'Mistakes happen!',
    messageKey: 'Click Undo any time to revert your last action. Use it as often as you need.'
  },
  {
    targetSelector: '.rte-shell__editor-area .ck-toolbar',
    titleKey: 'Formatting Toolbar',
    messageKey: 'Style text with bold, italic, headings, colors, lists, tables and more from here.'
  },
  {
    targetSelector: '.rte-shell__sidebar app-placeholder-palette',
    titleKey: 'Insert Fields',
    messageKey: 'Click any field on the left to insert it at your cursor position in the report.'
  },
  {
    targetSelector: '.rte-shell__tabs',
    titleKey: 'Switch Panels',
    messageKey: 'Switch between Fields and Properties. Properties lets you configure widgets and print settings.'
  },
  {
    targetSelector: '.rte-shell__sidebar-toggle',
    titleKey: 'Collapse Sidebar',
    messageKey: 'Hide the sidebar to get more room for editing.'
  },
  {
    targetSelector: '.rte-shell__preview-toggle',
    titleKey: 'Live Preview',
    messageKey: 'Toggle live preview to see how the report renders as you edit.'
  },
  {
    targetSelector: '.rte-shell__footer .rte-btn--outline-pdf',
    titleKey: 'Preview as PDF',
    messageKey: 'Render the report as a PDF in a separate view to check the printed output.'
  },
  {
    targetSelector: '.rte-shell__footer .rte-btn--outline',
    titleKey: 'Discard Changes',
    messageKey: 'Throw away all unsaved edits and return to the previous version.'
  },
  {
    targetSelector: '.rte-shell__footer .rte-btn--primary',
    titleKey: 'Save Changes',
    messageKey: 'Save your report when you are happy with the layout.'
  }
];
